import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { MailWarning, Loader2 } from "lucide-react";

export default function VerifyEmailBanner() {
  const { user } = useAuth();
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  if (!user || user.email_verified) return null;

  const resend = async () => {
    setSending(true);
    try {
      await api.post("/auth/resend-verification");
      setSent(true);
      toast.success(`Verification email sent to ${user.email}.`);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setSending(false); }
  };

  return (
    <div data-testid="verify-email-banner"
      className="mb-8 p-4 sm:p-5 border border-amber-500/40 bg-amber-500/5 flex flex-wrap items-center gap-4">
      <MailWarning size={18} className="text-amber-500 shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="text-sm font-semibold text-white">Verify your email to activate your account</div>
        <div className="text-xs text-neutral-400 mt-0.5">
          We sent a verification link to <span className="text-amber-500">{user.email}</span>. Unverified accounts can't claim a public username or purchase a membership.
        </div>
      </div>
      <button onClick={resend} disabled={sending || sent}
        data-testid="verify-banner-resend"
        className="px-4 py-2 border border-amber-500/50 text-amber-500 hover:bg-amber-500/10 text-xs font-mono-tech uppercase tracking-widest inline-flex items-center gap-2 disabled:opacity-50">
        {sending ? <><Loader2 size={12} className="animate-spin" /> Sending…</> : sent ? "Sent ✓" : "Resend email"}
      </button>
    </div>
  );
}
